import React from 'react';
import { Pie } from '@ant-design/plots';

interface OkrSummaryWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

const OkrSummaryWidget: React.FC<OkrSummaryWidgetProps> = ({ rowSpan = 1, colSpan = 1 }) => {
    const key = `${rowSpan}x${colSpan}`;
    const showOnlyFirst = key === '3x3';
    const showLeftOnly = ['3x3'].includes(key);
    const showBothCharts = showOnlyFirst && showLeftOnly;
    const isVertical = colSpan === 1;

    const entryData = [
        { type: 'GİRİŞİ YAPILMIŞ', value: 82 },
        { type: 'GİRİŞİ YAPILMAMIŞ', value: 18 },
    ];

    const typeData = [
        { type: 'STRATEJİK OKR', value: 40 },
        { type: 'DEPARTMAN OKR', value: 60 },
    ];

    const pieConfig = (data: any[], colors: string[]) => ({
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.7,
        legend: false,
        label: false,
        color: colors,
        statistic: {
            title: false,
            content: {
                style: { fontSize: 24, fontWeight: 600 },
                content: `${data[0].value}%`,
            },
        },
    });

    return (
        <div className="w-full h-full p-4 rounded shadow bg-white flex flex-col items-center">
            <h2 className="text-lg font-semibold text-center mb-4">OKR GİRİŞ</h2>

            <div className={`flex ${isVertical ? 'flex-col' : 'flex-row'} items-center justify-center gap-6 w-full`}>
                {/* Sol grafik */}
                <div className="bg-gray-100 p-3 rounded-xl flex flex-col items-center">
                    <div style={{ width: 140, height: 140 }}>
                        <Pie {...pieConfig(entryData, ['#fbb03b', '#7300ff'])} />
                    </div>
                    {!showOnlyFirst ? null : (
                        <>
                            <div className="text-xs mt-2 flex flex-col items-start">
                                <div className="flex items-center gap-2">
                                    <span className="w-3 h-3 rounded-full bg-[#fbb03b]" />
                                    GİRİŞİ YAPILMIŞ
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="w-3 h-3 rounded-full bg-[#7300ff]" />
                                    GİRİŞİ YAPILMAMIŞ
                                </div>
                            </div>
                            {/*<span className="text-xs text-blue-500 mt-2">April 2028</span>*/}
                        </>
                    )}
                </div>

                {/* Sağ grafik */}
                {showBothCharts && (
                    <div className="bg-gray-100 p-3 rounded-xl flex flex-col items-center">
                        <div style={{ width: 140, height: 140 }}>
                            <Pie {...pieConfig(typeData, ['#ff4d4f', '#00bcd4'])} />
                        </div>
                        <div className="text-xs mt-2 flex flex-col items-start">
                            <div className="flex items-center gap-2">
                                <span className="w-3 h-3 rounded-full bg-[#ff4d4f]" />
                                STRATEJİK OKR
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-3 h-3 rounded-full bg-[#00bcd4]" />
                                DEPARTMAN OKR
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OkrSummaryWidget;
